<script lang="ts">import { menuAutoCollapsed } from "../state";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { handleCustomerSupport, isMobile } from "@infinitro/global";
import { RemoteIcon } from "@infinitro/icons";
let isMenuCollapsed = false;
menuAutoCollapsed.subscribe((value) => {
	isMenuCollapsed = value;
});
$: useAlternative = $stateUi.sidebar.sidebarStyle === "alternative";
$: useAlternative2 = $stateUi.sidebar.sidebarStyle === "alternative2";
$: useAlternative4 = $stateUi.sidebar.sidebarStyle === "alternative4";
$: supportFullWidthMobile = $stateUi.sidebar.supportFullWidthMobile ?? false;
$: useLiveSupportLabel = $stateUi.sidebar.useLiveSupportLabel ?? false;
$: supportLabel = useLiveSupportLabel ? Verbiage.live_support : Verbiage.support;
$: showText = supportFullWidthMobile ? !isMenuCollapsed : !$isMobile && !isMenuCollapsed;
</script>

<button
	class:sidebar-button-alternative={useAlternative || useAlternative4}
	class:sidebar-button-alternative-4={useAlternative4}
	class:sidebar-button-alternative-2={useAlternative2}
	class="sidebar-button"
	class:collapsed={isMenuCollapsed}
	class:full-width-mobile={supportFullWidthMobile}
	on:click={handleCustomerSupport}
	aria-label={$t(supportLabel)}
>
	<div class="icon-wrapper">
		<RemoteIcon icon="SupportIcon" size={16} />
	</div>
	{#if showText}
		<span class="button-text" class:hide={isMenuCollapsed}>
			{$t(supportLabel)}
		</span>
	{/if}
</button>

<style>
	.sidebar-button {
		display: flex;
		height: 40px;
		width: 40px;
		align-items: center;
		justify-content: center;
		gap: 0.5rem;
}
@media (min-width: 1024px) {
		.sidebar-button {
				width: 100%;
				justify-content: flex-start;
		}
}
	.sidebar-button {
		border-radius: 16px;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		background: var(--gradient-alternative-4);
		font-size: 14px;
		color: var(--color-text-100);
		font-family: var(--font-main);
		padding: 0px;
}
	@media (min-width: 1024px) {
		.sidebar-button {
				padding-left: 0.625rem;
				padding-right: 0.625rem;
				padding-top: 0.75rem;
				padding-bottom: 0.75rem;
		}
}
	.sidebar-button:hover {
		opacity: 0.9;
}
	.sidebar-button:focus {
		border-color: var(--color-secondary-500);
		outline: 2px solid transparent;
		outline-offset: 2px;
}

	.sidebar-button-alternative {
		border-color: var(--color-accent-700);
		background-color: var(--color-background-500);
		border-radius: 12px;
}

	.sidebar-button-alternative:focus {
		border-color: var(--color-accent-700);
		outline: 2px solid transparent;
		outline-offset: 2px;
}

	.sidebar-button-alternative {
		background-image: unset;
	}

	.sidebar-button-alternative-4 {
		border-width: 0px;
		background-color: unset;
}

	.sidebar-button-alternative-2 {
		border-style: none;
		background-color: transparent;
		background-image: unset;
}

	.collapsed {
		width: 40px;
		justify-content: center;
}

	.icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		transition-property: transform;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 300ms;
}

	.button-text {
		white-space: nowrap;
		transition-property: opacity;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 300ms;
}

	.hide {
		width: 0px;
		overflow: hidden;
		opacity: 0;
}

	/* Mobile styles */
	@media (max-width: 1023px) {
		.sidebar-button {
				width: 40px;
				justify-content: center;
				padding: 0px;
		}

		.sidebar-button.full-width-mobile {
				width: 100%;
				justify-content: flex-start;
				padding-left: 0.625rem;
				padding-right: 0.625rem;
				padding-top: 0.75rem;
				padding-bottom: 0.75rem;
		}
	}
</style>
